export const IS_AUTHORIZED_PATH = "users/me";
export const USER_ORGANIZATIONS_PATH = "users/me/organizations";

export const ID_TOKEN_HINT_PATH = (organizationId: string) =>
  `users/me/organizations/${organizationId}/id-token-hint`;

// Because of Security Audit reports, we implemented in Common Platform Services dedicated endpoint to 100% invalidate token after sign out
export const invalidateTokenUrl = `/v1/auth/token`;
